import request from '@/utils/request'
import store from '@/store'
const url = store.getters.getPostUrl;
export default {
	getStatisticAll(param) {
		return request({
			url: url + '/alarm/getAlarmCount',
			method: 'post',
			data: param
		})
	},
	/* //全部报警统计
	 getStatisticAll() {
		   return request({
			   url: url + '/sys/statistic/all',
			   method: 'get'
		   })
	 }, */
	//市级报警统计
	getStatisticCity(param) {
		return request({
			url: url + '/device/getDeviceStateCount',
			method: 'post',
			data: param
		})
	},
	//获取地图信息
	getMapAll(param) {
		return request({
			url: url + '/device/getDeviceStateCount',
			method: 'post',
			data: param
		})
	},
	//获取右侧区域菜单列表
	getAreaList() {
		return request({
			url: url + '/area/page',
			method: 'get',
		})
	},
	//获取地图详细信息
	getMapList(param) {
		return request({
			url: url + '/device/getAreaDeviceDetail',
			method: 'post',
			data: param
		})
	},
  //通过客户ID获取地图详细信息
  getMapListByCustomerId(param) {
  	return request({
  		url: url + '/device/getAreaDeviceDetailByCustomerId',
  		method: 'post',
  		params: param
  	})
  },

}



// WEBPACK FOOTER //
// ./src/assets/js/map/map.js